// extracted by mini-css-extract-plugin
export default {"SwiperIcon":"SwiperIcon_SwiperIcon__J+BSH","IconHand":"SwiperIcon_IconHand__KH6DF","Arrow":"SwiperIcon_Arrow__IfMCq"};